import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { DocumentationItem } from '../../types/documentation';
import LinkedText from '../common/LinkedText';

interface TopicsSectionProps {
  items: DocumentationItem[];
}

const TopicsSection: React.FC<TopicsSectionProps> = ({ items }) => {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3, textAlign: 'left' }}>
        Topics
      </Typography>
      {items.map((item, index) => (
        <Accordion 
          key={index}
          sx={{ 
            mb: 2,
            '&:before': {
              display: 'none',
            },
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            borderRadius: '8px !important',
            overflow: 'hidden'
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              backgroundColor: '#fff',
              textAlign: 'left',
              '&:hover': {
                backgroundColor: '#f8f9fa'
              }
            }}
          >
            <Box sx={{ textAlign: 'left' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, textAlign: 'left' }}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left' }}>
                <LinkedText text={item.description} />
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: '#fafafa', textAlign: 'left' }}>
            <Typography variant="body1" sx={{ lineHeight: 1.7, textAlign: 'left' }}>
              <LinkedText text={item.details} />
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default TopicsSection;
